module.exports = __webpack_public_path__ + "static/media/digital-signage-img3.091ec07f.jpg";